import { PRICE_SELECTED } from "pu-data/QuoteSteps";

export const buildFabricationData = (arg) => {
  const { quoteStep, fabricationVariant, project_number, project_reference } = arg;
  if (quoteStep !== PRICE_SELECTED) return null;

  let form = new FormData();
  form.append('parameters[project_number]', project_number);
  form.append('parameters[project_reference]', project_reference);
  form.append('variant_id', fabricationVariant);
  $('.pcb-fabrication #hidden-fabrication-parameters input').each((i, input) => {
    form.append(input.name, input.value);
  })

  const input_file = $('#gerber-file')
  const file = input_file ? input_file.prop("files")[0] : null

  // If the file is present, it means the user wants to add a new file or replace it for this line item,
  // else we should not send the filename parameter or it will be unlinked in the backend
  if (file) {
    form.append('parameters[filename]', file);
  } else {
    form.delete('parameters[filename]');
  }

  return form;
}

export const buildForms = (args) => {
  if(!args) return [];

  const {quoteStep, fabricationVariant, project_number, project_reference} = args;
  const fabrication_form = buildFabricationData({quoteStep, fabricationVariant, project_number, project_reference});

  return fabrication_form ? [fabrication_form] : [];
}